import AnticipoVinculacion from './AnticipoVinculacion'

const DevolucionAgenteAduana = props => (
  <AnticipoVinculacion
    {...props}
    type={props.type || 'ingreso'}
    title='Devolución Agente Aduana'
    slug='devolucion-agente-aduana'
    counterpartyLabel='Agente de Aduana'
    amountLabel='Monto Devolución'
    classification='1-1-6-8 Anticipo Agente de Aduana'
  />
)

export default DevolucionAgenteAduana
